/* tslint:disable */
/* eslint-disable */
/**
 * Leads API
 * API for managing leads (potential customers from external sources)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SimulationOptionDto } from './SimulationOptionDto';
import {
    SimulationOptionDtoFromJSON,
    SimulationOptionDtoFromJSONTyped,
    SimulationOptionDtoToJSON,
    SimulationOptionDtoToJSONTyped,
} from './SimulationOptionDto';
import type { SimulationCoveragesDto } from './SimulationCoveragesDto';
import {
    SimulationCoveragesDtoFromJSON,
    SimulationCoveragesDtoFromJSONTyped,
    SimulationCoveragesDtoToJSON,
    SimulationCoveragesDtoToJSONTyped,
} from './SimulationCoveragesDto';

/**
 * DTO représentant une simulation d'assurance santé
 * @export
 * @interface SimulationSanteDto
 */
export interface SimulationSanteDto {
    /**
     * Code de la formule
     * @type {string}
     * @memberof SimulationSanteDto
     */
    formulaCode?: string;
    /**
     * Libellé de la formule
     * @type {string}
     * @memberof SimulationSanteDto
     */
    formulaLabel?: string;
    /**
     * Prime mensuelle
     * @type {number}
     * @memberof SimulationSanteDto
     */
    monthlyPremium?: number;
    /**
     * Prime annuelle
     * @type {number}
     * @memberof SimulationSanteDto
     */
    yearlyPremium?: number;
    /**
     * 
     * @type {SimulationCoveragesDto}
     * @memberof SimulationSanteDto
     */
    coverages?: SimulationCoveragesDto;
    /**
     * Options souscrites dans la simulation
     * @type {Array<SimulationOptionDto>}
     * @memberof SimulationSanteDto
     */
    options?: Array<SimulationOptionDto>;
}

/**
 * Check if a given object implements the SimulationSanteDto interface.
 */
export function instanceOfSimulationSanteDto(value: object): value is SimulationSanteDto {
    return true;
}

export function SimulationSanteDtoFromJSON(json: any): SimulationSanteDto {
    return SimulationSanteDtoFromJSONTyped(json, false);
}

export function SimulationSanteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimulationSanteDto {
    if (json == null) {
        return json;
    }
    return {
        
        'formulaCode': json['formulaCode'] == null ? undefined : json['formulaCode'],
        'formulaLabel': json['formulaLabel'] == null ? undefined : json['formulaLabel'],
        'monthlyPremium': json['monthlyPremium'] == null ? undefined : json['monthlyPremium'],
        'yearlyPremium': json['yearlyPremium'] == null ? undefined : json['yearlyPremium'],
        'coverages': json['coverages'] == null ? undefined : SimulationCoveragesDtoFromJSON(json['coverages']),
        'options': json['options'] == null ? undefined : ((json['options'] as Array<any>).map(SimulationOptionDtoFromJSON)),
    };
}

export function SimulationSanteDtoToJSON(json: any): SimulationSanteDto {
    return SimulationSanteDtoToJSONTyped(json, false);
}

export function SimulationSanteDtoToJSONTyped(value?: SimulationSanteDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'formulaCode': value['formulaCode'],
        'formulaLabel': value['formulaLabel'],
        'monthlyPremium': value['monthlyPremium'],
        'yearlyPremium': value['yearlyPremium'],
        'coverages': SimulationCoveragesDtoToJSON(value['coverages']),
        'options': value['options'] == null ? undefined : ((value['options'] as Array<any>).map(SimulationOptionDtoToJSON)),
    };
}

